import { createFileRoute } from '@tanstack/react-router'

import { TagsSection } from '@/features/organization/tags-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/tags')({
  component: TagsTab,
})

function TagsTab() {
  const { currentOrgId } = useAuth()
  return <TagsSection orgId={currentOrgId} />
}
